// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MangoHubGetPatientSummaryDetails {
    static getAttributeTypeMap() {
        return MangoHubGetPatientSummaryDetails.attributeTypeMap;
    }
}
MangoHubGetPatientSummaryDetails.discriminator = undefined;
MangoHubGetPatientSummaryDetails.attributeTypeMap = [
    {
        "name": "isiLink",
        "baseName": "isiLink",
        "type": "string"
    },
    {
        "name": "selectedServices",
        "baseName": "selectedServices",
        "type": "Array<MangoHubSelectedService>"
    },
    {
        "name": "prescriptions",
        "baseName": "prescriptions",
        "type": "Array<MangoHubGetPatientSummaryPrescription>"
    },
    {
        "name": "indications",
        "baseName": "indications",
        "type": "Array<MangoHubGetPatientSummaryDiagnosis>"
    },
    {
        "name": "prescriber",
        "baseName": "prescriber",
        "type": "MangoHubGetPatientSummaryPrescriber"
    },
    {
        "name": "patientInfo",
        "baseName": "patientInfo",
        "type": "MangoHubGetPatientInfo"
    },
    {
        "name": "medicalPayors",
        "baseName": "medicalPayors",
        "type": "Array<MangoHubGetPatientSummaryMedicalPayor>"
    },
    {
        "name": "pharmacyPayors",
        "baseName": "pharmacyPayors",
        "type": "Array<MangoHubGetPatientSummaryPharmacyPayor>"
    },
    {
        "name": "pharmacy",
        "baseName": "pharmacy",
        "type": "MangoHubGetPatientSummaryPharmacy"
    }
];
//# sourceMappingURL=mangoHubGetPatientSummaryDetails.js.map